import { Page } from '@/core/architecture'

import { DigitalMembershipCardDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * DigitalMembershipCardDetail Page
 * Implemented as a practical sample.
 */
export const DigitalMembershipCardDetail: Page = () => {
  const { state } = useViewModel()

  return <DigitalMembershipCardDetailTemplate state={state} />
}
